import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
    const { pathname } = useLocation();

    // useLayoutEffect statt useEffect: läuft vor dem Paint, dadurch wird die
    // neue Seite nie kurz an der alten Scroll-Position gezeigt.
    useLayoutEffect(() => {
        // Verhindert, dass der Browser beim Wechsel eine gemerkte Position
        // wiederherstellt.
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }

        // Je nach CSS ist mal <html>, mal <body> das scrollende Element –
        // beide zurücksetzen, damit es in jedem Fall greift.
        window.scrollTo(0, 0);
        if (document.documentElement) document.documentElement.scrollTop = 0;
        if (document.body) document.body.scrollTop = 0;
    }, [pathname]);

    return null;
};
